import React from 'react'
import newsletterConfig from '../../../newsletter-config.json'
import NewsletterSectionSocialMedia from './NewsletterSectionSocialMedia'
import NewsletterSectionAddress from './NewsletterSectionAddress'
import NewsletterSectionLogo from './NewsletterSectionLogo'
import NewsletterSectionTextLines from './NewsletterSectionTextLines'
import NewsletterSectionEnd from './NewsletterSectionEnd'
import NewsletterSectionSpacer from './NewsletterSectionSpacer'

const NewsletterFooter = ({
    stylesData,
    cinemaData,
    translation,
    socialMediaData,
    closingTextLines,
    currentCinemaUrl
}) => (
    <>
        <NewsletterSectionSpacer 
            paddingTop="55px"
        />

        {newsletterConfig.footerStructure.map(key => (
            'logo' === key ? (
                <NewsletterSectionLogo
                    key={key}
                    cinemaData={cinemaData}
                    width={newsletterConfig.cinemaLogoFooterWidth}
                    paddingTop="45px"
                    paddingBottom="5px"
                />
            ) : 'address' === key ? (
                <NewsletterSectionAddress
                    key={key}
                    cinemaData={cinemaData}
                    stylesData={stylesData}
                />
            ) : 'textlines' === key ? (
                <NewsletterSectionTextLines
                    key={key}
                    stylesData={stylesData}
                    closingTextLines={closingTextLines}
                />
            ) : 'socialmedia' === key ? (
                <NewsletterSectionSocialMedia 
                    key={key}
                    items={socialMediaData}
                    currentCinemaUrl={currentCinemaUrl}
                    paddingTop="20px"
                />
            ) : 'end' === key ? (
                <NewsletterSectionEnd
                    key={key}
                    stylesData={stylesData}
                    cinemaData={cinemaData}
                    translation={translation}
                />
            ) : null
        ))}
    </>

)

export default NewsletterFooter